import { OrderItemType } from '@mews-commander/data-access';
import { isProductOrderItemWithProductId, OrderItem } from '@mews-commander/types';
import {
    BulkCheckbox,
    ConvertedCurrencyValue,
    FlexItemNoShrink,
    FlexSpaceBetweenAlignCenter,
    SpacedLongDash,
    TooltippedSpan,
} from '@mews-commander/ui';
import { Typography, Stack } from '@optimus-web/core';
import { UnicodeEntity } from '@mews/enums';
import { lt } from '@mews/framework';
import ProductName from '../../../../../../components/commander-ui/ProductName';
import { OrderItemName } from '../../../../components';
import RebatedTag, { RebatedTagType } from '../../../../rebate/components/RebatedTag';
import RebateTag from '../../../../rebate/components/RebateTag';
import { TotalAmountAndCount } from '../../../../types';
import { isOrderItemTaxCorrection } from '../../../../rebate/selectors/orderItems';
import { ORDER_ITEM_CHECKBOX_DATA_TEST_ID } from '../../constants';

interface Props {
    orderItem: OrderItem;
    type: OrderItemType;
    allSelected: boolean;
    someSelected: boolean;
    isRebated: boolean;
    rebatedTagType: RebatedTagType;
    isRebate: boolean;
    isClosed: boolean;
    rebateIndex?: number;
    toggleSelect(): void;
    totalAmountAndCount: TotalAmountAndCount;
    showNotes?: boolean;
    showAgeCategory?: boolean;
}

export const OrderItemProductLabel: React.FC<Props> = ({
    orderItem,
    someSelected,
    type,
    allSelected,
    toggleSelect,
    totalAmountAndCount,
    isRebated,
    rebatedTagType,
    isRebate,
    isClosed,
    rebateIndex,
    showNotes = true,
    showAgeCategory = true,
}) => (
    <FlexSpaceBetweenAlignCenter data-product-row={orderItem.id}>
        <Stack itemAlignment="center" spacing="100">
            <TooltippedSpan
                tooltip={isOrderItemTaxCorrection(orderItem) ? lt('RebateItemsCheckboxDisabledTooltip') : null}
            >
                <BulkCheckbox
                    disabled={(isRebated && isClosed) || isOrderItemTaxCorrection(orderItem)}
                    allSelected={allSelected}
                    someSelected={someSelected}
                    onChange={toggleSelect}
                    data-test-id={ORDER_ITEM_CHECKBOX_DATA_TEST_ID}
                />
            </TooltippedSpan>
            <Stack itemAlignment="center">
                {isRebate ? <RebateTag rebateIndex={rebateIndex} /> : null}
                {isRebated ? <RebatedTag type={rebatedTagType} /> : null}
                <Typography textStyle="bodyMediumStrong" as="div">
                    {isProductOrderItemWithProductId(orderItem) && !showAgeCategory ? (
                        <ProductName productId={orderItem.data.value.productId} />
                    ) : (
                        <OrderItemName orderItem={orderItem} />
                    )}
                </Typography>
                <Typography textStyle="bodyMediumStrong" variant="secondary" as="div">
                    {type !== OrderItemType.Deposit && orderItem.notes && showNotes ? (
                        <>
                            {SpacedLongDash}
                            {orderItem.notes}
                        </>
                    ) : null}
                    {SpacedLongDash}
                    {totalAmountAndCount.unitCount}
                    {UnicodeEntity.MultiplicationSign}
                </Typography>
            </Stack>
        </Stack>
        <FlexItemNoShrink>
            <ConvertedCurrencyValue amount={totalAmountAndCount.amount} />
        </FlexItemNoShrink>
    </FlexSpaceBetweenAlignCenter>
);
